export interface IStep {
  type: IStepType
  layout: IStepLayout
  template: IStepTemplate
  isTooltip?: boolean
  isMultiple?: boolean
  isSkip?: boolean
  isOverlay?: boolean
  options?: IStepSelect[]
  optionsMapType?: IStepType[]
  optionsMap?: {
    [k: string]: IStepSelect[]
  }
}

export enum IStepLayout {
  HOME = 'HOME',
  STEP_EMPTY = 'STEP_EMPTY', // rename
}

export enum IStepTemplate {
  TILES = 'TILES',
  DROPDOWN_SELECT = 'DROPDOWN_SELECT',
  OVERVIEW = 'OVERVIEW',
  CALENDAR = 'CALENDAR',
  CONTACT = 'CONTACT',
  THANK_YOU = 'THANK_YOU',
}

export enum IStepType {
  PRODUCT_TYPE = 'PRODUCT_TYPE',
  MACHINE_TYPE = 'MACHINE_TYPE',
  SERVICE = 'SERVICE',
  ELECTRICITY = 'ELECTRICITY',
  BRANCH = 'BRANCH',
  EMPLOYEES = 'EMPLOYEES',
  SHIFT_SYSTEM = 'SHIFT_SYSTEM',
  PAYMENT = 'PAYMENT',
  INSTALLATION = 'INSTALLATION',
  REGION = 'REGION',
  OVERVIEW = 'OVERVIEW',
  CALENDAR = 'CALENDAR',
  CONTACT_LONG = 'CONTACT_LONG',
  CONTACT_SHORT = 'CONTACT_SHORT',
  THANK_YOU = 'THANK_YOU',
  SUBPAGE_HOME = 'SUBPAGE_HOME',
  FOOTER_HOME = 'FOOTER_HOME',
}

export enum IStepLandingIconKeys {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
  LIST_ARROW = 'LIST_ARROW',
}

export enum IStepFooterHomeIconKeys {
  OVERLAY = 'OVERLAY',
}

export enum IStepSelectProductType {
  HOT_DRINK = 'hot-drink',
  SNACK = 'snack',
  WATER = 'water',
  COLD_DRINK = 'cold-drink',
  SOUP = 'soup',
  FRESH = 'fresh',
}

export enum IStepSelectMachineType {
  HOT_DRINK = 'hot-drink',
  CATERING = 'catering',
  WATER = 'water',
  COLD_DRINK = 'cold-drink',
  SNACK = 'snack',
}

export enum IStepSelectService {
  USER_FRIENDLINESS = 'user-friendliness',
  PRODUCT_RANGE = 'product-range',
  TECHNICAL_SERVICE = 'technical-service',
  HYGIENE = 'hygiene',
  PRICE_VALUE = 'price-value',
}

export enum IStepSelectBranch {
  PRODUCTION_LOGISTICS = 'logistics-logistics',
  HEALTH = 'health',
  PUBLIC_OR_EDUCATION = 'public-or-education',
  GASTRONOMY = 'gastronomy',
  CATERING = 'catering',
  OTHER = 'other',
}

export enum IStepSelectElectricity {
  ELECTRICITY_AND_WATER = 'electricity-and-water',
  ELECTRICITY = 'electricity',
  WATER = 'water',
  NONE = 'none-above',
}

export enum IStepSelectEmployees {
  BIG_1 = '1-29',
  BIG_2 = '30-99',
  BIG_3 = '100-499',
  BIG_4 = '500+',
  SMALL_1 = '1-49',
  SMALL_2 = '50-99',
  SMALL_3 = '100-249',
  SMALL_4 = '250+',
}

export enum IStepSelectShiftSystem {
  NONE = 'none',
  SHIFT_2 = '2-shift',
  SHIFT_3 = '3-shift',
  SHIFT_4 = '4-shift',
}

export enum IStepSelectPayment {
  CARD = 'card',
  CASH = 'cash',
  OTHER = 'other',
}

export enum IStepSelectInstallation {
  SELF = 'self',
  SERVICE = 'service',
  UNKNOW = 'unkown',
}

export enum IStepSelectRegion {
  DE = 'de',
  AUS = 'aus',
  CH = 'ch',
  OTHER = 'other',
}

export enum IPreselectStepRoute {
  BRANCH = 'BRANCH',
  PRODUCT = 'PRODUCT'
}

export const IStepSelectSkip: string = 'skip'

export type IStepSelect = string |
  IStepSelectProductType |
  IStepSelectMachineType |
  IStepSelectBranch |
  IStepSelectService |
  IStepSelectElectricity |
  IStepSelectEmployees |
  IStepSelectShiftSystem |
  IStepSelectPayment |
  (typeof IStepSelectSkip)

export interface IStepsSelected {
  [key: string]: IStepSelect[]
}

export interface IOption {
  id: string
  text: string
  isSelected: boolean
  iconKeys?: string[]
}

export interface IMap {
  [k: string]: string | string[]
}

export enum IHomeStyle {
  HOME_PAGE = 'home-page',
  PRE_FOOTER = 'pre-footer',
  SUB_PAGE = 'sub-page',
}
